import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import MenuHorizontal from "../../layouts/MenuHorizontal";
import {
  Container,
  Icon,
  Form,
  Transition,
  Dropdown,
} from "semantic-ui-react";
import { create } from "../../../actions/competidor";
import { find as findJogadores } from "../../../actions/jogador";

import * as FormValidator from "../../../utils/formValidator";
import { Rodape } from "../../layouts/Rodape";
import Erro from "../../layouts/messages/Erro";

class CadastrarCompetidor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      competidor: { ...props.competidor },
      file: null,
      errors: {},
      sucesso: false,
      loading: false,
    };
  }

  componentDidMount = async () => {
    await this.props.findJogadores();
  };

  onChange = (e) => {
    this.setState({
      competidor: { ...this.state.competidor, [e.target.name]: e.target.value },
      errors: {},
    });
  };

  onChangeSelect = (e, { name, value }) =>
    this.setState({
      competidor: { ...this.state.competidor, [name]: value },
      errors: {},
    });

  validate = (competidor) => {
    const errors = {};
    if (!competidor.nome) errors.nome = "Nome é obrigatório";
    if (!competidor.jogadores)
      errors.jogadores =
        "Vincule o nickname ou nome da equipe a um jogador ou equipe";
    return errors;
  };

  onSubmitCadastrar = async (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.competidor);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      await this.props.create(this.state.competidor);
      this.setState({
        loading: false,
        sucesso: FormValidator.objIsEmpty(this.props.errors),
        errors: this.props.errors,
      });
    }
  };

  getJogadores = () => {
    return this.props.jogadores.map((cat) => {
      return {
        key: cat._id,
        value: cat._id,
        text: cat.nome,
      };
    });
  };

  render() {
    const { competidor, errors, loading, sucesso } = this.state;
    return (
      <div>
        <MenuHorizontal />
        <Container style={{ paddingTop: "10px" }}>
          <Transition
            duration={{ show: 1200, hide: 0 }}
            animation="fade up"
            transitionOnMount={true}
            visible={sucesso}
          >
            <div
              style={{
                textAlign: "center",
                marginTop: "40px",
              }}
            >
              <Icon name="check circle outline" size="massive" color="green" />
              <br />
              <h3>Competidor cadastrado com sucesso</h3>
              <Link to="/dashboard/competidores" size="small">
                Voltar
              </Link>
            </div>
          </Transition>
          {!sucesso && (
            <Form
              onSubmit={this.onSubmitCadastrar}
              loading={loading}
              autoComplete={"off"}
            >
              <div className="ui-crud-form">
                <h3>Cadastro de Competidor</h3>
                <Form.Field error={!!errors.nome} className="ui-crud-form-container">
                  <input
                    className="ui-crud-form-input"
                    name="nome"
                    type="text"
                    onChange={this.onChange}
                    value={competidor.nome}
                    autoFocus
                    id="nome"
                    required
                  />
                  <label htmlFor="nome" className="ui-crud-form-label">Nickname ou nome da equipe</label>
                  <Erro text={errors.nome} />
                </Form.Field>
                <Form.Field error={!!errors.jogadores}>
                  <label htmlFor="status">Jogador ou equipe </label>
                  {!loading && (
                    <Dropdown
                      name="jogadores"
                      placeholder="Jogadores"
                      fluid
                      multiple
                      search
                      selection
                      options={this.getJogadores()}
                      noResultsMessage={"Nenhum jogador encontrado"}
                      onChange={this.onChangeSelect}
                      value={competidor.jogadores}
                    />
                  )}
                  <Erro text={errors.jogadores} />
                </Form.Field>
                <div style={{ textAlign: "center" }}>
                  <button
                    loading={loading}
                    disabled={loading}
                    className="ui-btn-1 ui-btn-theme-1"
                  >
                    Cadastrar Competidor
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Container>
        <Rodape />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    jogadores: state.jogador.jogadores,
    competidor: state.competidor.competidor,
    competidores: state.competidor.competidores,
    quantidade: state.competidor.quantidade,
    errors: state.competidor.errors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      create,
      findJogadores,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CadastrarCompetidor);
